import _ from 'lodash';
import { useMemo } from 'react';
import { Table, TableColumn } from '@scale/scaleui';
import { Skeleton } from '@mui/material';

interface LoadingTableProps {
  columns: TableColumn[];
  numRows?: number;
  rowHeight?: number;
}

export function makeLoadingRowCellFunction(rowHeight: number) {
  return function LoadingRow() {
    return (
      <div>
        {_.range(rowHeight).map(r => (
          <Skeleton key={r} />
        ))}
      </div>
    );
  };
}

export const LoadingTable = ({ columns, numRows = 10, rowHeight = 1 }: LoadingTableProps) => {
  const transformedColumns = useMemo(
    () =>
      columns.map(c => ({
        ...c,
        cell: makeLoadingRowCellFunction(rowHeight),
      })),
    [columns, rowHeight],
  );
  const rows = useMemo(
    () =>
      _.range(numRows).map(() => ({
        key: _.uniqueId(),
      })),
    [numRows],
  );
  return <Table columns={transformedColumns} data={rows} />;
};
